export default {"src":"/_next/static/media/no-image-placeholder.5e8fa1d8.svg","height":407,"width":330,"blurWidth":0,"blurHeight":0};